<template>
	<transition name="fade">
		<div v-show="open" class="modal-popup" :class="{ active: open }">
			<div class="popup-overlay" @click="closeModal"></div>

			<div class="container">
				<div class="popup">
					<div class="row">
						<modal-side v-once title="Modal.Login.Title" component-class="popup-login-side">
							<ul>
								<li>
									<p>{{ $t('Modal.Login.NotYetRegistered') }}?</p>
									<router-link :to="{ name: 'registerUser' }" @click.native="closeModal">
										{{ $t('Modal.Login.RegisterHere') }}
									</router-link>
								</li>
								<li class="margin-top-50">
									<p>{{ $t('Modal.Login.AreYouALawyer') }}?</p>
									<router-link :to="{ name: 'registerLawyer' }" @click.native="closeModal">
										{{ $t('Modal.Login.RegisterHere') }}
									</router-link>
								</li>
							</ul>
						</modal-side>

						<div class="col-md-9 col-sm-12 col-xs-12 popup-container text-center">
							<ValidationObserver ref="form">
								<form autocomplete="off" @submit.prevent="sendForm">
									<div class="popup-form login-form margin-top-100">
										<form-errors-box :errors="errors"></form-errors-box>

										<div class="col-md-12 col-sm-12 col-xs-12 text-left">
											<form-input
												v-model="accountEmail"
												:show-errors="showErrors"
												label="Misc.Email"
												name="account-email"
												rules="required|email"
											></form-input>
										</div>

										<div class="col-md-12 col-sm-12 col-xs-12 text-left">
											<form-input
												v-model="accountPassword"
												:show-errors="showErrors"
												label="Misc.Password"
												component-type="password"
												name="account-password"
												rules="required"
											></form-input>
										</div>

										<div class="col-md-12 col-sm-12 col-xs-12 margin-bottom-40 text-left">
											<div class="row">
												<!-- <div class="col-md-6 text-left">
													<input
														id="remember"
														v-model="remember"
														type="checkbox"
														name="remember"
														class="remember"
														value="1"
													/>
													<label for="remember">
														<small>{{ $t('Modal.Login.KeepMeLoggedIn') }}</small>
													</label>
												</div> -->

												<div class="col-md-12 text-right">
													<router-link :to="{ name: 'passwordRecovery' }" class="forgot" @click.native="closeModal">
														{{ $t('Link.PasswordRecovery') }}
													</router-link>
												</div>
											</div>
										</div>
									</div>

									<form-button
										:disabled="!accountEmail || !accountPassword || loading"
										:is-loading="loading"
										label="Button.Login"
										component-class="button-3"
									></form-button>
								</form>
							</ValidationObserver>
						</div>

						<div class="close-btn" @click="closeModal">
							<i class="fa fa-close"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import FormButton from '@/components/atoms/FormButton'
import FormErrorsBox from '@/components/atoms/FormErrorsBox'
import FormInput from '@/components/atoms/FormInput'
import ModalHelper from '@/mixins/ModalHelper'
import ModalSide from '@/components/modals/ModalSide'

export default {
	name: 'LoginModal',
	components: {
		FormButton,
		FormErrorsBox,
		FormInput,
		ModalSide,
	},
	mixins: [ModalHelper],
	data() {
		return {
			accountEmail: '',
			accountPassword: '',
			remember: false,
		}
	},
	mounted() {
		// Listen for open modal event
		this.$root.$on('open-login-modal', () => {
			this.open = !this.open
		})
	},
	destroyed() {
		// This prevents from having memory leaks
		this.$root.$off('open-login-modal')
	},
	methods: {
		sendForm() {
			this.$refs.form.validate().then((success) => {
				if (!success) {
					this.showErrors = true
					return false
				}

				this.loading = true

				// Perform login
				this.$store
					.dispatch('retrieveToken', {
						username: this.accountEmail,
						password: this.accountPassword,
						remember: this.remember,
					})
					.then(() => {
						// Retrieve account info
						this.$store
							.dispatch('retrieveAccount', {
								remember: this.remember,
							})
							.then(() => {
								this.loading = false

								// Update locale after login
								this.$root.$i18n.locale = this.$store.getters.locale

								// Close modal
								this.closeModal()

								// Reset form
								this.email = this.password = ''
								requestAnimationFrame(() => {
									this.$refs.form.reset()
								})

								// Redirect after login (move account to the dashboard page)
								this.$router.push({ name: 'dashboard' })
							})
					})
					.catch((error) => {
						this.loading = false

						// Reset form state
						this.email = this.password = ''
						requestAnimationFrame(() => {
							this.$refs.form.reset()
						})

						// Manage errors
						this.showErrors = false
						this.errors = error.response.data.info
							? Object.values(error.response.data.info)
							: new Array(error.response.data.message)
					})
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/utils/modals/login/LoginModal.vue